/* eslint-disable camelcase */
import {
  Link,
  createSearchParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { MouseEventHandler, useEffect, useState } from "react";
import { makeLangUrl } from "helpers/makeLangUrl";

// Constants
import { MOBILE_NAVIGATION_ENUMS } from "constants/navigation/mobileNavigation";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";
import { useCheckBalance } from "hooks/useCheckBalance";

// Types
import { GAME_MODE } from "types/Games";
import { ALIAS_GAME } from "types/Banners";
import ArrowIcon from "assets/icons/glory/arrow-back.svg?react";

import urlRoutes from "url/index";

import { useSelector } from "react-redux";
import { useSupport } from "../../../hooks/useSupport";
import { useCountriesStore } from "../../../stores/countries";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { getLocalStorageItem } from "../../../utils/localStorage";
import { STORAGE_CURRENCY_FROM_LINK } from "../../../constants/variables";
import * as authSelectors from "../../../redux/auth/selectors";
import NotificationCircle from "../../atoms/NotificationCircle";

import "./styles.sass";

type MobileNavigationItemProps = {
  id: MOBILE_NAVIGATION_ENUMS;
  name: string;
  icon: JSX.Element;
  url: string;
  hasNotify?: boolean;
  // nameImage?: JSX.Element;
  // customColor?: string;
};

const MobileNavigationItem = (props: MobileNavigationItemProps) => {
  const { id, name, url, icon, hasNotify } = props;
  const { isAuthenticated } = useSelector(authSelectors.all);

  const t = useTranslate();
  const navigate = useNavigate();
  const location = useLocation();
  const checkBalance = useCheckBalance();
  const GTM = useGTM();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const supportInit = useSupport();
  const countryCode = useCountriesStore((state) => state.countryCode);
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const { isDesktop } = useBreakpoint();

  // const iconClass = classNames("MobileNavigationItem__icon", {
  //   MobileNavigationItem__icon_custom: !customColor,
  //   MobileNavigationItem__icon_aviator: id === MOBILE_NAVIGATION_ENUMS.AVIATOR,
  // });

  useEffect(() => {
    if (countryCode) {
      setIsCountryOpen(false);
    }
  }, [countryCode]);

  const handleChatWootInit = () => {
    const currencyFromLink = getLocalStorageItem(STORAGE_CURRENCY_FROM_LINK);
    if (!isAuthenticated && !countryCode && !currencyFromLink) {
      if (isDesktop) {
        setIsCountryOpen(!isCountryOpen);
      } else {
        navigate({
          search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.countries })}`,
        });
      }
    } else {
      GTM.clickSupport();
      supportInit();
    }
  };

  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (id === MOBILE_NAVIGATION_ENUMS.PROFILE) {
      GTM.clickProfilePage();
      // navigate(`${location.pathname}?page=${GET_POPUP_TYPES.page.profile}`, {
      //   replace: true,
      // });
    }
    if (id === MOBILE_NAVIGATION_ENUMS.MY_BONUS) {
      GTM.clickBonusPage();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.TRANSACTIONS_HISTORY) {
      GTM.clickTransactionHistory();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.GAMES_HISTORY) {
      GTM.clickGameHistory();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.AVIATOR) {
      e.preventDefault();
      GTM.clickAviator();
      const isBalancePositive = checkBalance();
      if (isBalancePositive) {
        navigate(
          {
            pathname: makeLangUrl(
              urlRoutes.routes.casino.game({ game: ALIAS_GAME.AVIATOR }),
            ),
            search: `?${createSearchParams({
              [GET_PARAMS.MODE]: GAME_MODE.REAL,
            })}`,
          },
          { state: { state: location.state }, replace: true },
        );
      }
    }
    if (id === MOBILE_NAVIGATION_ENUMS.TOURNAMEMTNS) {
      GTM.clickTournaments();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.WELCOME_BONUS) {
      GTM.clickGetWelcomeBonus();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.ACCESS_RECOVERY) {
      GTM.clickPasswordRecovery();
    }
    if (id === MOBILE_NAVIGATION_ENUMS.SUPPORT) {
      e.preventDefault();
      handleChatWootInit();
    }
  };

  return (
    <Link
      to={makeLangUrl(url)}
      className="MobileNavigationItem"
      onClick={handleLinkClick}
    >
      <div className="MobileNavigationItem__icon">{icon}</div>
      <div className="MobileNavigationItem__content">
        <div className="MobileNavigationItem__name">
          {t(name)} {hasNotify ? <NotificationCircle /> : null}
        </div>
        <div className="MobileNavigationItem__arrow">
          <ArrowIcon />
        </div>
      </div>
    </Link>
  );

  // from master 28/02/25
  // return (
  //   <Link
  //     to={makeLangUrl(url)}
  //     className="MobileNavigationItem"
  //     onClick={handleLinkClick}
  //   >
  //     <div className={iconClass} style={{ fill: customColor }}>
  //       {icon}
  //     </div>
  //     <div
  //       className="MobileNavigationItem__name"
  //       style={{ color: customColor }}
  //     >
  //       {nameImage || t(name)}
  //     </div>
  //     {hasNotify ? <NotificationCircle /> : null}
  //   </Link>
  // );
};

export default MobileNavigationItem;
